module.exports = __webpack_public_path__ + "static/media/chat.96caa01d.svg";